import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_TASK_SAGA } from "../sagaTypes";
import { loaderAction, taskFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { TASK_FORM_INITIAL } from "../initialStateConstant";
import { getTasksSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/update_task`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateTask(args) {
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('task_id', args.data.id);
        formData.append('description', args.data.description);
        formData.append('target_date', args.data.target_date);
        formData.append('target_time', args.data.target_time);
        formData.append('responsible', args.data.responsible);
        formData.append('status', args.data.status);
        formData.append('color', args.data.color);
        formData.append('urgent', args.data.urgent);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Запрашиваем список задач
            yield put(getTasksSagaAction());
            // Очищаем и закрываем форму задачи
            yield put(taskFormAction(TASK_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateTask() {
    yield takeLatest(UPDATE_TASK_SAGA, workerUpdateTask);
}